import script from "./SyncOptionsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncOptionsModal.vue?vue&type=script&lang=ts&setup=true"

import "./SyncOptionsModal.vue?vue&type=style&index=0&id=d0a12694&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a12694"]])

export default __exports__